import { Trans, t } from '@lingui/macro';
import { DialogHeader, DialogContent, DialogFooter, IconButton, Avatar, Typography, } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { TextField, TextAreaField, SubmitButton, FormDialog } from 'shared/domains/forms';
import { schema } from './validation';
import { Container } from './styled';
export function KeyForm(props) {
    const { onClose, onSubmit, initialValues } = props;
    const titleText = initialValues
        ? t({
            message: 'Edit key',
            comment: 'Edit key modal - title',
        })
        : t({
            message: 'Create new key',
            comment: 'Create new key modal - title',
        });
    const buttonText = initialValues
        ? t({
            message: 'Save',
            comment: 'Edit key modal - submit button text',
        })
        : t({
            message: 'Generate key',
            comment: 'Create new key modal - submit button text',
        });
    return (<FormDialog initialValues={{
            name: (initialValues === null || initialValues === void 0 ? void 0 : initialValues.name) || '',
            description: (initialValues === null || initialValues === void 0 ? void 0 : initialValues.description) || '',
        }} onSubmit={onSubmit} validationSchema={schema} onClose={onClose}>
      <DialogHeader title={titleText} media={<Avatar appearance="light" size="xl">
            <Falcon icon="key"/>
          </Avatar>} action={<IconButton $round appearance="ghost" type="button" onClick={onClose}>
            <Falcon icon="xmark"/>
          </IconButton>}/>
      <DialogContent>
        <Container>
          <Typography>
            <Trans comment="Create/edit key modal - Description">
              Name your API key and add a description to easily manage it later.
            </Trans>
          </Typography>
          <TextField name="name" label={t({ message: 'Name', comment: 'Create/edit key modal - Name input label' })}/>
          <TextAreaField name="description" label={t({
            message: 'Description',
            comment: 'Create/edit key modal - Description input label',
        })}/>
        </Container>
      </DialogContent>
      <DialogFooter>
        <SubmitButton>{buttonText}</SubmitButton>
      </DialogFooter>
    </FormDialog>);
}
